import { render, staticRenderFns } from "./CategoryMainSlider.vue?vue&type=template&id=e30071e0&scoped=true"
import script from "./CategoryMainSlider.vue?vue&type=script&lang=js"
export * from "./CategoryMainSlider.vue?vue&type=script&lang=js"
import style0 from "./CategoryMainSlider.vue?vue&type=style&index=0&id=e30071e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e30071e0",
  null
  
)

export default component.exports